<div class="progress-loader" *ngIf="loading" [ngClass]="{'loader-dark': isDarkTheme, 'loader-light': !isDarkTheme}">
  <mat-spinner ></mat-spinner>
</div>



